import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=0d6c1824&"
import script from "./FileList.vue?vue&type=script&lang=ts&"
export * from "./FileList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports